import React, { useEffect, useState, useMemo } from "react";
import "../../StyleSheet/MainComponent/Role/Role.scss";
import PageTemplate from "../../Component/MainComponent/PageTemplate/PageTemplate";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Header from "../../Component/AppComponent/Header/Header";
import home from "../../Assets/AppComponent/Logo/Home.svg";
import project from "../../Assets/AppComponent/Logo/PROJECT ORG.svg";
import plant from "../../Assets/AppComponent/Logo/PLANT.svg";
import { setClientListRetrieveActions, setplantListRetrieveActions, projectid, setCommonPostActions, SetCommonPostUpdateResponse,CreateProjectUpdateResponse,UpdateProjectupdateResponse } from "../../Redux/Slice";
import ProjectCreatePopup from "../../Component/AppComponent/Popup/ProjectCreatePopup";
import Delete from "../../Component/AppComponent/Popup/Delete";
import ReactTable from "../../Component/AppComponent/Table";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { plantProjects } from "../../Context/apidata";
import axios from "axios";

function ProjectTemplate() {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const plantList = useSelector((state) => state.fetchPlant);
  const projectNames = useSelector((state) => state.fetchClient);
  const [tabledata, settabledata] = useState([])
  const [plantName, setPlantName] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [datacount, setdatacount] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [projectPopup, setProjectPopup] = useState(false);
  const [editPayload, setEditPayload] = useState({});
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [plantId, setPlantId] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const plantresid = useSelector((state) => state.SideBarActive.plantid)
  const projectresid = useSelector((state) => state.SideBarActive.projectid)
  const [ProjectCommon, setProjectCommon] = useState(false)
  const [Projectdetails, setProjectdetails] = useState()
  const [ProjectCommonFolder, setProjectCommonFolder] = useState(['ATTENDANCE', "INVOICE_WORKING", "DIG_INVOICE", "PF_DECLARATION", "ESI_DECLARATION", "ECR_STATEMENT", "GST_TAX CHALLAN", "PROFESSIONAL_TAX CHALLAN", "BANK_STATEMENT", "PO_AND_WO", "WAGE_REGISTER", "MATERIAL_DC", "OTHERS"])
  const [checkedItems, setCheckedItems] = useState([]);
  const CommonPostResData = useSelector((state) => state.CommonPostData.CommonPost)

  const createProjectdata=useSelector((state)=>state.createProject)
  const updateProjectdata =useSelector((state)=>state.updateProject) 
  useEffect(()=>{
    //console.log(createProjectdata,updateProjectdata,"ooo")

    if(createProjectdata?.createProject?.data){
      dispatch(setClientListRetrieveActions({
        search: searchQuery,
        page: dtpageindex,
        id: plantresid
      }));
      dispatch(CreateProjectUpdateResponse())
    }
    if(updateProjectdata?.updateProjectData?.data){
      dispatch(setClientListRetrieveActions({
        search: searchQuery,
        page: dtpageindex,
        id: plantresid
      }));
      dispatch(UpdateProjectupdateResponse())
    }
  },[createProjectdata,updateProjectdata])

  const getPlantDetailsById = (idValue) => {
    if (plantList.plantListRetrieve?.data?.length > 0) {
      const plant = plantList.plantListRetrieve?.data.find((plant) => plant.id === idValue);
      return plant;
    }
  };
  const createProjectStatus = useSelector(
    (state) => state.createProject.createProject
  );
  const updateProjectStatus = useSelector(
    (state) => state.updateProject.updateProjectData
  );

  useEffect(() => {
    if (projectNames?.clientListRetrieve?.data?.length > 0) {
      settabledata(projectNames?.clientListRetrieve?.data)
      setdatacount(projectNames?.clientListRetrieve?.values)
    }
    else {
      settabledata([])
      setdatacount(0)

    }
  }, [projectNames])
  useEffect(() => {
    dispatch(setClientListRetrieveActions({
      search: searchQuery,
      page: dtpageindex,
      id: plantresid
    }));
  }, [createProjectStatus, updateProjectStatus, dtpageindex, searchQuery]);
  useEffect(() => {
    dispatch(setplantListRetrieveActions());
    dispatch(setClientListRetrieveActions({
      search: searchQuery,
      page: dtpageindex,
      id: plantresid

    }));
  }, [dispatch]);

  useEffect(() => {
    const value = getPlantDetailsById(plantresid);
    setPlantName(value?.plant);
  }, [plantList]);
  const handleEdit = (value) => {
    setPlantId(value.plant.id);
    setEditPayload(value);
    setProjectPopup(true);
  };
  const handleView = (value, e) => {
    //console.log(value.id, "iddd")
    //projectid
    dispatch(projectid(value.id))
    setProjectPopup(false);
    navigate(`/projectWps/${value.id}`);
  };
  const handleRefresh = () => {
    dispatch(setClientListRetrieveActions({
      search: searchQuery,
      page: dtpageindex,
      id: plantresid

    }));
  };
  const handleDelete = (value, e) => {
    setSelectedData(value);
    setDeletePopup(true);
  };
  const handleConfirmDelete = (value) => {
    axios({
      method: "delete",
      url: plantProjects,
      params: {
        id: selectedData.id,
      },
    }).then((res)=>{
      toast.info(`Deleted Successfully`, {
        position: toast.POSITION.TOP_RIGHT,
className: "toast-message",
      });
      dispatch(setClientListRetrieveActions({
        search: searchQuery,
        page: dtpageindex,
        id: plantresid
      }));
    }).catch((err)=>{
      //console.log(err)
      toast.info(` ${err.response.data.status.message} `, {
        position: toast.POSITION.TOP_RIGHT,
className: "toast-message",
      });
  
    })    
    setDeletePopup(false);
  };
  const breadcrumbsData = [
    {
      id: "1",
      href: "/",
      source: home,
      title: "Home",
    },
    {
      id: "2",
      href: `/plantProject/`,
      source: plant,
      title: "Plant",
    },
  ];

  const projectColumn = useMemo(
    () => [
      {
        Header: "Plant",
        accessor: "",
        Cell: (row) => {
          //console.log(row.row.original);
          return <div>{row.row.original?.plant.plant}</div>;
        },
      },
      {
        Header: "Project",
        accessor: "project",
      },
      // {
      //   Header: "To",
      //   accessor: "", // Assuming "to_email" is the key in your data object
      //   Cell: (row) => {
      //     //console.log(row.row.original);
      //     return <div>{row.row.original?.project_emails[0]?.to_email}</div>;
      //   },
      // },
      {
        Header: "To",
        accessor: "", // Assuming "to_email" is the key in your data object
        Cell: (row) => {
          var emails = ""
          row.row.original?.project_emails[0].to_email.map(
            (email) => emails+=email+","
          );
          //console.log(emails,"akjdfjahkdj");
          let displayEmails = "";
          if (emails && emails.length > 0) {
            displayEmails = emails.slice(0, 30)
            if (emails.length > 10) {
              displayEmails += ", ...";
            }
          }
          return <div>{displayEmails}</div>;
        },
      },
      

      
      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <div className="plantProjectActions">
              <button
                type="button"
                onClick={(e) => handleEdit(row.row.original, e)}
              >
                <span style={{ color: "#ef4d39" }}>
                  {" "}
                  <i
                    class="fa-solid fa-pen"
                    style={{
                      fontSize: "13px",
                      paddingRight: "3px",
                      color: "#ef4d39",
                    }}
                  ></i>
                  Edit{" "}
                </span>
              </button>

              <button
                type="button"
                onClick={(e) => handleDelete(row.row.original, e)}
              >
                <span style={{ color: "#ef4d39" }}>
                  {" "}
                  <i
                    class="fa-regular fa-trash-can"
                    style={{
                      fontSize: "15px",
                      paddingRight: "3px",
                      paddingBottom: "3px",
                      color: "#ef4d39",
                    }}
                  ></i>
                  Delete{" "}
                </span>
              </button>
              <button
                type="button"
                onClick={(e) => handleView(row.row.original, e)}
              >
                <i
                  onClick={(e) => handleView(row.row.original, e)}
                  className="bi bi-eye-fill"
                ></i>{" "}
                View
              </button>
              {/* <button className="plant_common" onClick={(e) => {
                setProjectdetails(row.row.original)
                setProjectCommon(!ProjectCommon)
              }}>
                <i class="bi bi-folder-plus"></i>
                Project Common
              </button> */}
            </div>
          );
        },
      },
    ],
    []
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const handleSubmit = () => {
    if (checkedItems.length > 0) {
      dispatch(setCommonPostActions({
        type: "project",
        project_common: checkedItems,
        plant: Projectdetails.plant.plant,
        project: Projectdetails.project
      }))
    } else {
      toast.info(`Select Folder`, {
        position: toast.POSITION.TOP_RIGHT,
className: "toast-message",
      });
    }

  }

  useEffect(() => {
    setProjectCommon(false)
    dispatch(SetCommonPostUpdateResponse())
    setCheckedItems([])
  }, [CommonPostResData])

  const handleCheckboxChange = (event) => {
    const target = event.target;
    const itemName = target.name;
    const isChecked = target.checked;

    if (isChecked) {
      setCheckedItems([...checkedItems, itemName]);
    } else {
      setCheckedItems(checkedItems.filter(item => item !== itemName));
    }
  };
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        {/* <button className="SideBarCreate">CREATE PROJECT</button> */}
        <Header breadCrumbsData={breadcrumbsData} heading="Projects" />
        <div className="UserDetails" style={{ padding: "0" }}>
          <button
            onClick={() => {
              setProjectPopup(true);
              setPlantId(plantresid);
            }}
            type="submit"
            style={{
              background:
                "linear-gradient(90deg, #F26639 -3.66%, #F79C37 -3.65%, #EF4D39 100.34%)",
            }}
            className="custom-button"
          >
            CREATE
          </button>
        </div>
        <p>Selected Plant: {plantName}</p>

        <ReactTable
          columns={projectColumn}
          data={tabledata}
          pagesize={pagesize}
          pageindex={pageindex}
          dtpagesize={dtpagesize}
          dtpageindex={dtpageindex}
          datacount={datacount}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          search={true}

        />
        <ProjectCreatePopup
          show={projectPopup}
          setShow={setProjectPopup}
          // onSubmit={handleSubmit}
          editPayload={editPayload}
          plantId={plantId}
          refresh={handleRefresh}
          setEditPayload={setEditPayload}
        />
      </div>
      {/* {deletePopup && ( */}
      <Delete
        show={deletePopup}
        setShow={setDeletePopup}
        handleConfirmDelete={handleConfirmDelete}
        selectedData={selectedData}
      />
      {/* )} */}

      {ProjectCommon && (
        <Modal
          // size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={ProjectCommon}
          // onHide={handleClose}
          className="modelman"
        >
          <Modal.Header>
            <Modal.Title>
              Plant Common Folder
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <div>
                {ProjectCommonFolder.map((ele, index) => (
                  <div key={index}>
                    <input
                      type="checkbox"
                      id={ele}
                      name={ele}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor={ele}>{ele}</label>
                  </div>
                ))}

              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => { setProjectCommon(false); setCheckedItems([]) }}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              style={{ backgroundColor: "#f26639", border: "none" }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}

export default ProjectTemplate;
